import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Globe, 
  Smartphone, 
  Cloud, 
  Palette, 
  Database,
  RefreshCw
} from 'lucide-react';
import './ServicesOverview.css';

const services = [
  {
    icon: <Globe size={32} />,
    title: 'Web Development',
    description: 'Custom websites, web applications, and e-commerce solutions built with modern technologies.',
    path: '/services/web-development'
  },
  {
    icon: <Smartphone size={32} />,
    title: 'Mobile App Development',
    description: 'Native and cross-platform mobile apps for iOS and Android with stunning UX.',
    path: '/services/mobile-apps'
  },
  {
    icon: <Cloud size={32} />,
    title: 'Cloud Solutions',
    description: 'Scalable cloud infrastructure, migration, and management services.',
    path: '/services/cloud-solutions'
  },
  {
    icon: <Palette size={32} />,
    title: 'UI/UX Design',
    description: 'Beautiful, intuitive interfaces that users love and convert.',
    path: '/services/ui-ux-design'
  },
  {
    icon: <Database size={32} />,
    title: 'SaaS Development',
    description: 'End-to-end SaaS platform development from MVP to enterprise scale.',
    path: '/services/saas-development'
  },
  {
    icon: <RefreshCw size={32} />,
    title: 'Digital Transformation',
    description: 'Modernize your business processes with cutting-edge technology.',
    path: '/services/digital-transformation'
  }
];

const ServicesOverview = () => {
  return (
    <section className="services-overview section">
      <div className="container">
        <h2 className="section-title">Our <span className="blue-text">Services</span></h2>
        <p className="section-subtitle">
          We offer comprehensive IT solutions to help businesses grow and succeed in the digital age.
        </p>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <Link to={service.path} className="service-link">
                Learn More →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;